__turbopack_context__.v({
  "footer": "Onboarding-module-scss-module__Do2I3W__footer",
  "step": "Onboarding-module-scss-module__Do2I3W__step",
  "steps": "Onboarding-module-scss-module__Do2I3W__steps",
  "wrapper": "Onboarding-module-scss-module__Do2I3W__wrapper",
});
